import { type FC, useId } from 'react'
import { type IntlShape, useIntl } from 'react-intl'

import { IconCaretDown } from '@redteclab/icons'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { type ContactFormState } from '../../../contact-form'
import { type OpenableControls } from '../../../generic-hooks'

import { useDirectFormDialogContext } from './DirectContactFormDialogContext'
import { DirectContactFormProductsInputField } from './DirectContactFormProductsInputField'

export const DirectContactFormOrderInputFieldLoggedIn: FC<{
  formState: ContactFormState
  isProductType: (intl: IntlShape, subject: string) => boolean
  productSelectionModalControls: OpenableControls
}> = ({ formState, isProductType, productSelectionModalControls }) => {
  const intl = useIntl()

  const subOrderNumberId = useId()
  const { setOrderSelectionDialogTitle, subOrderNumber } =
    useDirectFormDialogContext()

  return (
    <div className="flex flex-col justify-between gap-2 tablet:flex-row">
      <FormControl
        className="mb-2 w-full cursor-pointer"
        error={!formState.model.validator.isPropertyValid('orderId')}
        onChange={(event): void => {
          formState.makeInputProps('orderId').onChange(event)
        }}
        onClick={(event) => {
          event.preventDefault()
          setOrderSelectionDialogTitle(
            intl.formatMessage({ id: 'direct.contact.form.select.order' }),
          )
          productSelectionModalControls.handleOpen()
        }}
        required
        value={subOrderNumber ? `${subOrderNumber}-1` : ''}
      >
        <FormLabel className="text-dark-primary-max" htmlFor={subOrderNumberId}>
          {intl.formatMessage({
            id: 'direct.contact.form.order.number',
          })}
        </FormLabel>
        <Input
          className="caret-transparent"
          endAdornment={
            <IconCaretDown className="-mr-2 size-6 text-dark-brand" />
          }
          id={subOrderNumberId}
          slotProps={{
            input: {
              'data-qa-id': 'contact-form-orderId-logged-in',
              style: {
                cursor: 'pointer',
              },
            },
          }}
        />
        {formState.model.validator.getFirstErrorFor('orderId') ? (
          <FormHelperText
            className="text-dark-error"
            data-qa-id="contact-form-orderId-logged-in-error-msg"
          >
            {formState.model.validator.getFirstErrorFor('orderId')}
          </FormHelperText>
        ) : null}
      </FormControl>

      {subOrderNumber &&
      formState.model.subject &&
      isProductType(intl, formState.model.subject ?? '') ? (
        <DirectContactFormProductsInputField
          formState={formState}
          productSelectionModalControls={productSelectionModalControls}
        />
      ) : null}
    </div>
  )
}
